export default __webpack_public_path__ + "static/media/unilogo.22608033.jpeg";